"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var eappBridge=function(e,n){return new Promise(function(o,t){dd.dtBridge({m:e,args:n,onSuccess:function(e){"function"==typeof n.success?n.success(e):"function"==typeof n.onSuccess&&n.onSuccess(e),o(e)},onFail:function(e){"function"==typeof n.fail?n.fail(e):"function"==typeof n.onFail&&n.onFail(e),t(e)}})})};exports.default=eappBridge;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@3.0.14@dingtalk-jsapi/lib/bridge/eapp.js
// module id = 215
// module chunks = 106